const DB_NAME = 'fromas-db';
const DB_VERSION = 1;
const STORE_NAME = 'release_reads';

function openDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME);
            }
        };

        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

function makeKey(email: string, version: string, prop_id: number) {
    return `${email}::${version}::${prop_id}`;
}

export async function hasReadRelease(
    email: string,
    version: string,
    prop_id: number
): Promise<boolean> {
    if (!email || !version || !prop_id) return false;

    const db = await openDB();
    return new Promise((resolve) => {
        const tx = db.transaction(STORE_NAME, 'readonly');
        const store = tx.objectStore(STORE_NAME);
        const req = store.get(makeKey(email, version, prop_id));

        req.onsuccess = () => resolve(Boolean(req.result));
        req.onerror = () => resolve(false);
    });
}

export async function markReadRelease(
    email: string,
    version: string,
    prop_id: number
): Promise<void> {
    if (!email || !version) return;

    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const store = tx.objectStore(STORE_NAME);
        const request = store.openCursor();

        request.onsuccess = () => {
            const cursor = request.result;
            if (cursor) {
                const key = cursor.key as string;
                const parts = key.split('::');
                // remove old record
                if (parts[0] === email && parts[2] === prop_id.toString()) {
                    cursor.delete();
                }
                cursor.continue();
            } else {
                // create new record
                store.put(
                    {
                        email,
                        version,
                        readAt: new Date().toISOString(),
                    },
                    makeKey(email, version, prop_id)
                );
            }
        };
        tx.oncomplete = () => resolve();
        tx.onerror = () => reject(tx.error);
    });
}
